import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static classes = ["toggle"]
  declare readonly toggleClasses: string[]

  static values = { offset: Number }
  declare readonly offsetValue: number

  private lastScrollY = window.scrollY
  private promoBarHeight = 0

  connect(): void {
    const promoDomRect = document.getElementById("js-sitewide-promo")?.getBoundingClientRect()
    this.promoBarHeight = promoDomRect?.height || 0
  }

  handleScroll(): void {
    const currentScrollY = window.scrollY

    if (
      currentScrollY > this.lastScrollY &&
      currentScrollY > this.offsetValue + this.promoBarHeight
    ) {
      this.hide()
    } else {
      this.show()
    }

    this.lastScrollY = currentScrollY
  }

  private show(): void {
    this.element.classList.remove(...this.toggleClasses)
  }

  private hide(): void {
    this.element.classList.add(...this.toggleClasses)
  }
}
